import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'b-proxy-route',
  template: '<router-outlet></router-outlet>'
})
export class ProxyRouteComponent {
}
